(function () {
    "use strict";

    angular
        .module("app")
        .directive("compoundSearchHelp", ["SearchFactory", compoundSearchHelp]);

    function compoundSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.compoundKey = "";
                        scope.compoundDesc = "";
                        scope.displayValue = "";
                        scope.prevDisplayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.CompoundDesc === scope.displayValue)) {
                        
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.compoundSearch(scope.sapBrandId, function (compound) {
                        scope.compoundKey = compound ? compound.CompoundKey : "";
                        scope.compoundDesc = compound ? compound.CompoundDesc : "";
                        scope.displayValue = scope.compoundDesc;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue]);
                };

                scope.displayValue = scope.CompoundDesc;
                scope.prevDisplayValue = scope.displayValue;

                scope.$watch("compoundDesc", function (newValue) {
                    scope.displayValue = newValue;
                });
            },
            scope: { compoundKey: "=", compoundDesc: "=", readOnly: "=", required: "=", controlName: "@", sapBrandId: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

